/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    document.body.classList.add("is-ios");
  }  

    //  Fix search popdown scroll issue: Enable page scrolling when search is open and allow click-outside-to-close
  function initSearchScrollFix() {
    const searchPopdown = document.getElementById('search-popdown');
    const searchUnderlay = document.querySelector('span[data-search-underlay]');
    const closeButtons = document.querySelectorAll('.search__predictive__close__inner[data-close-popdown]');
    const searchToggleButtons = document.querySelectorAll('a[data-popdown-toggle="search-popdown"]');

    if (!searchPopdown) return;

    // Function to remove scroll lock
    function removeScrollLock() {
      document.body.removeAttribute('data-scroll-lock-saved-overflow-y-property');
      document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
      document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
      document.body.removeAttribute('data-scroll-lock-locked');
      document.body.removeAttribute('data-scroll-lock-filled-gap');
      document.body.removeAttribute('data-scroll-lock-current-fill-gap-method');
      document.documentElement.removeAttribute('data-scroll-locked');
      
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.width = '';
    }
    function clearSearchContent() {
      const searchInput = searchPopdown.querySelector('input[data-predictive-search-input]');
      if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      const customSearchContainer = document.querySelector('.custom_search_shk');
      if (customSearchContainer) {
        customSearchContainer.innerHTML = '';
      }
      const searchResults = searchPopdown.querySelector('.header__search__results');
      if (searchResults) {
        searchResults.innerHTML = '';
      }
      const searchStatus = searchPopdown.querySelector('[data-predictive-search-status]');
      if (searchStatus) {
        searchStatus.textContent = '';
      }
      const searchLoader = document.querySelector('.search-loader');
      if (searchLoader) {
        searchLoader.style.display = 'none';
      }
      const searchResetButton = searchPopdown.querySelector('.search-reset');
      if (searchResetButton) {
        searchResetButton.classList.add('is-hidden');
      }
    }
    function closeSearch() {
      clearSearchContent();
      
      if (searchPopdown) {
        searchPopdown.classList.remove('is-visible');
      }
      if (searchUnderlay) {
        searchUnderlay.classList.remove('underlay--visible');
      }
      removeScrollLock();
    }
    // Make underlay clickable and ensure it's visible when search is open
    if (searchUnderlay) {
      searchUnderlay.style.cursor = 'pointer';
      searchUnderlay.style.pointerEvents = 'auto';
      
      // Close search when clicking on underlay
      searchUnderlay.addEventListener('click', function(e) {
        if (e.target === searchUnderlay) {
          closeSearch();
        }
      });
    }

    // Monitor for search opening and remove scroll lock
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isVisible = searchPopdown.classList.contains('is-visible');
          if (isVisible) {
            if (searchUnderlay) {
              searchUnderlay.classList.add('underlay--visible');
            }
            setTimeout(removeScrollLock, 50);
          } else {
            if (searchUnderlay) {
              searchUnderlay.classList.remove('underlay--visible');
            }
          }
        }
      });
    });

    observer.observe(searchPopdown, {
      attributes: true,
      attributeFilter: ['class']
    });
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeSearch();
      });
    });
    searchToggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        setTimeout(function() {
          if (searchPopdown.classList.contains('is-visible')) {
            if (searchUnderlay) {
              searchUnderlay.classList.add('underlay--visible');
            }
            removeScrollLock();
          }
        }, 100);
      });
    });
    if (searchPopdown.classList.contains('is-visible')) {
      if (searchUnderlay) {
        searchUnderlay.classList.add('underlay--visible');
      }
      removeScrollLock();
    }

    //for clicks outside the search popdown area
    document.addEventListener('click', function(e) {
      if (!searchPopdown.classList.contains('is-visible')) return;
      const searchContent = searchPopdown.querySelector('.search__predictive__outer');
      if (searchContent && !searchContent.contains(e.target) && !searchPopdown.contains(e.target)) {
        const clickedToggle = e.target.closest('a[data-popdown-toggle="search-popdown"]');
        if (!clickedToggle) {
          closeSearch();
        }
      }
    });
  }
   if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchScrollFix);
  } else {
    initSearchScrollFix();
  }
  

  const quickViewPopup = document.getElementById("quick-view-popup");
  const closeQuickView = document.getElementById("close-quick-view");
  if (quickViewPopup && closeQuickView) {
    quickViewPopup.addEventListener("click", function (event) {
      const content = quickViewPopup.querySelector(".quick-view-content");
      if (!content.contains(event.target)) {
        closeQuickView.click();
      }
    });
  }

  attn("init", {
    enableBackInStock: true,
    backInStockContainerSelector: "#attn-waitlist-trigger",
  });

  // Generate srcset for responsive images
  function generateSrcset(baseSrc) {
    const widths = [187, 190, 251, 270, 345, 374, 380, 502, 540, 690, 960];
    return widths
      .map((w) => {
        const h = Math.round((w * 490) / 392);
        return `${baseSrc}?crop=center&width=${w}&height=${h} ${w}w`;
      })
      .join(", ");
  }
  // Remove existing event listeners first to prevent duplicates
   function swatchimage_change() {
    const labels = document.querySelectorAll(
      ".collection__products .swatch__button label"
    );

    labels.forEach((label) => {
      if (label.dataset.bound === "true") return;
      label.dataset.bound = "true";

      label.addEventListener("click", function (e) {
        e.preventDefault();

        const clickedLabel = e.currentTarget;
        const selectedColorRaw = clickedLabel.dataset.exactColor || "";

        const productContainer =
          clickedLabel.closest("product-grid-item") ||
          clickedLabel.closest(".grid-product") ||
          clickedLabel.closest(".product-item");

        if (!productContainer || !selectedColorRaw) return;

        const primaryImage = productContainer.querySelector(".primary-image");
        const variantImages = productContainer.querySelectorAll(
          ".variant-images-container img"
        );

        if (!primaryImage || variantImages.length === 0) return;

        if (!primaryImage.dataset.originalSrc) {
          primaryImage.dataset.originalSrc = primaryImage.src;
          primaryImage.dataset.originalSrcset = primaryImage.srcset;
        }

        const normalizeColor = (val) =>
          val
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/\//g, "-"); 

        const selectedNormalized = normalizeColor(selectedColorRaw);
        let foundMatch = false;

        variantImages.forEach((img) => {
          const imgColorRaw = img.dataset.color || "";
          const imgColor = normalizeColor(imgColorRaw);

          if (imgColor === selectedNormalized) {
            const newSrc = img.src?.trim();
            const newSrcset = generateSrcset(newSrc);

            const imageWrapper = productContainer.querySelector(
              ".product-grid-item__image-wrapper.is-active"
            );
            const productWrapper = productContainer.closest(".product-grid-item");

            if (!imageWrapper) return;

            const imageContainers = imageWrapper.querySelectorAll(".product-image-container");
            const lastContainer = imageContainers[imageContainers.length - 1];
            if (!lastContainer) return;

            const primaryBlock = lastContainer.querySelector(".relative img");
            if (!primaryBlock) return;

            if (!newSrc) {
              productWrapper?.classList.add("swatch-image-empty");
              console.warn("Empty image source");
              return;
            }

            primaryBlock.setAttribute("src", newSrc);
            primaryBlock.setAttribute("srcset", newSrcset);
            primaryBlock.setAttribute("data-src", newSrc);
            primaryBlock.setAttribute("data-srcset", newSrcset);
            primaryBlock.setAttribute("alt", selectedNormalized);

            primaryBlock.style.opacity = "0";
            primaryBlock.style.transition = "opacity 0.3s ease-in-out";
            requestAnimationFrame(() => {
              primaryBlock.style.opacity = "1";
            });

            foundMatch = true;
          }
        });

        if (!foundMatch && primaryImage.dataset.originalSrc) {
          primaryImage.src = primaryImage.dataset.originalSrc;
          primaryImage.srcset = primaryImage.dataset.originalSrcset;
        }

        productContainer.querySelectorAll(".swatch__button label").forEach((l) =>
          l.classList.remove("active-swatch")
        );
        clickedLabel.classList.add("active-swatch");
      });
    });
  }
  swatchimage_change();

  document.querySelectorAll(".collection__content .grid-product__swatches-wrapper")
    .forEach((wrapper) => {
      const swatches = wrapper.querySelectorAll(".custmswatches");
      if (swatches.length <= 3) {
        wrapper.style.paddingRight = "0";
      }
  });

  // Slick Swatch Reinit
  function initSwatchSlider() {
    $(".grid-product__swatches-wrapper .slick-swatches").each(function () {
      const $el = $(this);
      if ($el.hasClass("slick-initialized")) {
        $el.slick("unslick");
      }
      $el.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 3 } },
          { breakpoint: 480, settings: { slidesToShow: 3 } },
        ],
      });
    });
  }
  $(document).ready(function () {
      setTimeout(function () {
        initSwatchSlider();
        swatchimage_change();
      }, 4000);
  });

  function initCollectionSort() {
    document.querySelectorAll("a[data-sort-link]").forEach(function (link) {
      // Prevent multiple bindings
      link.removeEventListener("click", handleSortClick);
      link.addEventListener("click", handleSortClick);
    });
  }

  function handleSortClick(e) {
    e.preventDefault();

    const sortValue = this.getAttribute("data-value");
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortValue);

    const productContainer = document.querySelector(".collection__products");
    const filterContainer = document.querySelector(
      ".collection__active__filters"
    );
    if (productContainer) {
      productContainer.innerHTML =
        "<p style='text-align: center;' class='loading'>Loading...</p>";
    }

    fetch(url.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelector(".collection__products");
        const newFilters = doc.querySelector(".collection__active__filters");
        if (newProducts && productContainer) {
          productContainer.innerHTML = newProducts.innerHTML;
        }

        if (newFilters && filterContainer) {
          filterContainer.innerHTML = newFilters.innerHTML;
        }

        // Update active sort UI state
        document
          .querySelectorAll("li.popout-list__item")
          .forEach((item) =>
            item.classList.remove("popout-list__item--current")
          );
        this.closest("li").classList.add("popout-list__item--current");
        history.pushState(null, "", url.href);

        // Re-init any post-load functions here
        initCollectionSort(); // Rebind sort links
        initSwatchSlider && initSwatchSlider();
        swatchimage_change && swatchimage_change();
      });
  }

  $(document).ready(function () {
    const collectionEl = document.querySelector(".collection__products");
    if (collectionEl) {
      let wasLoading = collectionEl.classList.contains("is-loading");

      const observer = new MutationObserver(() => {
        const isLoading = collectionEl.classList.contains("is-loading");
        if (wasLoading && !isLoading) {
          initCollectionSort();
          initSwatchSlider();
          swatchimage_change();
          initStyleFilter();
          swatchimage_change();

          document.querySelectorAll(".sidebar__navigation__list__item radio-swatch")
            .forEach(function (swatch) {
              const filterGroup = swatch.closest(".sidebar__filter__group");
              if (filterGroup) {
                const accordionTrigger = filterGroup.querySelector(
                  "[data-accordion-trigger]"
                );
                if (accordionTrigger) {
                  accordionTrigger.click();
                } else {
                  // console.log('Accordion trigger not found in:', filterGroup);
                }
              } else {
                // console.log('No .sidebar__filter__group found for:', swatch);
              }
            });
        }
        wasLoading = isLoading;
      });

      observer.observe(collectionEl, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    if ($("aside.seti.collection__filters__wrapper").hasClass("is-hidden")) {
      $("aside.seti.collection__filters__wrapper").addClass("hide");
    }
    $("#accordion-stylecs").hide();
    // Click handler for sidebar heading (custom style toggle)
    $(".sidebar__heading.js.custom_sty").on("click", function () {
      const $aside = $("aside.seti.collection__filters__wrapper");
      const $form = $(".collection__filters__inner form");
      const $accordion = $("#accordion-stylecs");

      // Toggle visibility of sidebar
      if ($aside.hasClass("is-hidden") || $aside.hasClass("hide")) {
        $aside.removeClass("is-hidden hide");
        $aside.removeClass("hidden");
        $aside.addClass("drawer--visible");
      } else {
        $aside.addClass("is-hidden hide");
      }

      // Toggle drawer visibility based on form class
      if ($form.hasClass("is-hidden")) {
        $aside.addClass("drawer--visible");
        $accordion.hide();
      } else {        
        $form.addClass("is-hidden");
        $("#accordion-stylecs").hide();
      }

      // Toggle accordion display
      $accordion.css( "display", $accordion.css("display") === "none" ? "block" : "none" );
    });

    // Click handler for pricing accordion button
    $("button.sidebar__heading.accordion-priceds").on("click", function () {
      setTimeout(function () {
        initSwatchSlider();
        swatchimage_change();
      }, 4000);

      const $aside = $("aside.seti.collection__filters__wrapper");
      const $form = $(".collection__filters__inner form");

      if ($aside.hasClass("is-hidden")) {
        $aside.addClass("hide");
        $(
          "button.sidebar__heading.js.custom_sty .icon-theme-stroke"
        ).removeClass("rotate");
      } else if ($aside.hasClass("hide")) {
        $(
          "button.sidebar__heading.js.custom_sty .icon-theme-stroke"
        ).removeClass("rotate");
        $aside.removeClass("hide").addClass("drawer--visible");
        $aside.removeClass("hidden");
        $form.removeClass("is-hidden");
      } else {
        const $accordion = $("#accordion-stylecs");
        $aside.addClass("drawer--visible");
        $aside.removeClass("hide");
        $form.removeClass("is-hidden");
        $aside.removeClass("hidden");
        $accordion.hide();
      }
    });

    $(".product-image-wrapper").on("click", function (event) {
      event.stopPropagation();
      event.preventDefault();

      var mediaId = $(this).closest(".product__media").attr("data-media-id");
      var zoomButton = $(this)
        .closest(".product__media")
        .find(".test.media__button--zoom");
      if (zoomButton.length > 0) {
        zoomButton.trigger("click");
      }
    });

    $(".test.media__button--zoom").on("click", function (event) {
      event.stopPropagation();
    });
  });

  // variables into the global scope.
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sidebar__navigation__list__item radio-swatch")
      .forEach(function (swatch) {
        swatch.addEventListener("click", function (event) {
          const filterGroup = swatch.closest(".sidebar__filter__group");
          if (filterGroup) {
            const accordionTrigger = filterGroup.querySelector(
              "[data-accordion-trigger]"
            );
            if (accordionTrigger) {
              accordionTrigger.click();
            }
          }
        });
      });

    initStyleFilter();
    swatchimage_change();
    const urlParams = new URLSearchParams(window.location.search);
    let constraint = urlParams.get("constraint");

    if (constraint) {
      constraint = constraint.replace(/\+/g, "-").toLowerCase();
      const styleLi = document.querySelector(
        `.style-list li[data-style-filter="${constraint}"]`
      );
      if (styleLi) styleLi.click();
    } else {
      const allLi = document.querySelector(
        `.style-list li[data-style-filter="all"]`
      );
      if (allLi) allLi.classList.add("active");
    }
    initCollectionSort();

    if (window.innerWidth > 767) {
      const toggleButtons = document.querySelectorAll(".toggleGalleryBtn");
      toggleButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const sectionId = this.getAttribute("data-section-id");
          const section = document.querySelector(
            `.shk_look_campgn.section-look[data-section-id="${sectionId}"]`
          );
          const slideItems_d = section.querySelectorAll(".slide-item");
          if (section) {
            if (section.style.display === "none" || !section.style.display) {
              section.style.display = "block";
              this.textContent = "Hide Gallery";
              slideItems_d.forEach((slide) => {
                slide.style.display = "block";
              });
            } else {
              section.style.display = "none";
              this.textContent = "View Gallery";
            }
          }
        });

        // Initialize button text based on current section state
        const sectionId = button.getAttribute("data-section-id");
        const section = document.querySelector(
          `.shk_look_campgn.section-look[data-section-id="${sectionId}"]`
        );
        if (section) {
          if (section.style.display === "none" || !section.style.display) {
            button.textContent = "View Gallery";
          } else {
            button.textContent = "Hide Gallery";
          }
        }
      });
    } else {
      const toggleButtons = document.querySelectorAll(".toggleGalleryBtn");
      toggleButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const sectionId = this.getAttribute("data-section-id");
          const section = document.querySelector(
            `.parent_stl.mob[data-section-id="${sectionId}"]`
          );
          const slideItems = section.querySelectorAll(".slide-item");

          if (section) {
            if (section.style.display === "none" || !section.style.display) {
              section.style.display = "block";
              slideItems.forEach((slide) => {
                slide.style.display = "block";
              });
              this.textContent = "Hide Gallery";
            } else {
              section.style.display = "none";
              this.textContent = "View Gallery";
            }
          }
        });
      });
    }

    // Toggle Styles panel
    const stylesButton = document.querySelector(
      ".sidebar__heading.js.custom_sty"
    );
    const stylesPanel = document.getElementById("accordion-stylecs");
    const activeFiltersWrapper = document.querySelector(
      ".collection__active__filters__wrapper"
    );

    if (stylesButton && stylesPanel && activeFiltersWrapper) {
      stylesButton.addEventListener("click", function () {
        const isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", !isExpanded);
        stylesPanel.style.display = isExpanded ? "none" : "block";
        activeFiltersWrapper.classList.remove("is-hidden");

        // Hide the main filters if showing styles
        const mainFiltersForm = document.querySelector(
          ".collection__filters__inner form"
        );
        if (mainFiltersForm) {
          mainFiltersForm.style.display = isExpanded ? "" : "none";
        }
      });
    }

    // Toggle Filters sidebar
    const filtersButton = document.querySelector(
      ".collection__layout button.accordion-priceds"
    );
    const filterSidebar = document.querySelector(
      "aside.collection__filters__wrapper.seti"
    );

    if (filtersButton && filterSidebar) {
      filtersButton.addEventListener("click", function () {
        const isHidden = filterSidebar.classList.contains("is-hidden");

        if (isHidden) {
          filterSidebar.classList.remove("is-hidden");
          filterSidebar.classList.add(
            "drawer--visible",
            "filters--default-visible"
          );

          // Ensure styles panel is hidden when showing main filters
          if (stylesPanel) {
            stylesPanel.style.display = "none";
            if (stylesButton) {
              stylesButton.setAttribute("aria-expanded", "false");
            }
          }

          // Show the main filters form and active filters
          const mainFiltersForm = document.querySelector(
            ".collection__filters__inner form"
          );
          if (mainFiltersForm) {
            mainFiltersForm.style.display = "";
          }
          activeFiltersWrapper.classList.remove("is-hidden");
        } else {
          filterSidebar.classList.add("is-hidden");
          filterSidebar.classList.remove(
            "drawer--visible",
            "filters--default-visible"
          );
        }
      });
    }

    // Initialize Slick sliders for swatches
    const swatchElements = document.querySelectorAll(".slick-swatches");
    if (swatchElements.length > 0) {
      swatchElements.forEach(function (el) {
        const cells = el.querySelectorAll(".carousel-cell");
        const swatchesCount = cells.length;

        if (swatchesCount > 3 && !$(el).hasClass("slick-initialized")) {
          if (cells.length === 0) return;

          $(el).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            infinite: false,
            prevArrow:
              '<button type="button" class="slick-prev">Previous</button>',
            nextArrow: '<button type="button" class="slick-next">Next</button>',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
            ],
          });
        } else {
          el.style.display = "flex";
          el.style.justifyContent = "flex-end";
        }
      });
    }

    const closeButton = document.querySelector(".pswp__button--close");
    if (closeButton) {
      closeButton.addEventListener("click", function (event) {
        document.body.style.overflow = "";
        document.body.style.width = "auto";
        event.preventDefault();
        closePhotoSwipe();
      });
    }

    function closePhotoSwipe() {
      const pswpElement = document.querySelector(".pswp");
      if (pswpElement) {
        pswpElement.classList.remove("pswp--open");
      }
    }

    var $slider = $(".customlook.slider");
    var $progressBar = $(".progress-bar");

    // Initialize Slick slider with autoplay and show part of the next slide
    $slider.slick({
      dots: false, 
      infinite: true,
      speed: 1300,
      slidesToShow: 1, 
      slidesToScroll: 1,
      arrows: false, 
      autoplay: true, 
      autoplaySpeed: 2000, 
      centerMode: true,
      variableWidth: true,
      pauseOnHover: false, 
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
          },
        },
      ],
    });

    // Initialize progress bar when Slick slider is initialized
    $slider.on("init", function (event, slick) {
      $slider.css("visibility", "visible"); // Ensure slider is visible after initialization
      updateProgressBar(slick.currentSlide, slick.slideCount);
    });

    // Update progress bar on slide change
    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        updateProgressBar(nextSlide, slick.slideCount);
      }
    );

    // Function to update progress bar
    function updateProgressBar(currentSlide, totalSlides) {
      var calc = ((currentSlide + 1) / totalSlides) * 100;
      $progressBar.css("width", calc + "%");
    }

    var sidebar = document.querySelector(".collection__filters__wrapper");
    var footer = document.querySelector("footer");
    if (sidebar) {
      var sidebarTop = sidebar.offsetTop;
      function checkScroll() {
        var scrollPosition = window.scrollY + window.innerHeight;
        var footerTop = footer.offsetTop;

        if (scrollPosition >= footerTop) {
          sidebar.style.position = "relative";
        } else {
          sidebar.style.position = "sticky";
        }
      }
      window.addEventListener("scroll", checkScroll);
    }
  });

  function initStyleFilter() {
    document
      .querySelectorAll(".style-list li[data-style-filter]")
      .forEach(function (styleItem) {
        styleItem.removeEventListener("click", styleClickHandler); 
        styleItem.addEventListener("click", styleClickHandler);
      });
  }

  // Keep controller in outer scope so can abort old requests
  let activeFetchController;

  function styleClickHandler() {
  let rawTag = this.getAttribute("data-style-filter") || "";

  const constraintTag = rawTag.replace(/[\s+]+/g, "-").toLowerCase();
  const gridContainer = document.querySelector(".collection__products .js-grid");
  if (!gridContainer) return;

  document.querySelectorAll(".style-list li").forEach((li) =>
    li.classList.remove("active")
  );
  this.classList.add("active");

  // Build clean URL
  let newUrl;
  if (constraintTag === "all") {
    newUrl = window.location.pathname;
  } else {
    newUrl = `${window.location.pathname}?constraint=${constraintTag}`;
  }
  history.pushState(null, "", newUrl); 
  gridContainer.innerHTML =
    '<p class="loading" style="text-align: center;">Loading...</p>';
  
  // Hide pagination while loading
  const paginationContainer = document.querySelector(".pagination-custom");
  if (paginationContainer) {
    paginationContainer.style.display = "none";
  }

  const fetchUrl =
    constraintTag === "all"
      ? `${window.location.pathname}?view=grid-ajax`
      : `${window.location.pathname}?constraint=${constraintTag}&view=grid-ajax`;

  // Abort old fetch if still running
  if (activeFetchController) {
    activeFetchController.abort();
  }
  activeFetchController = new AbortController();

  fetch(fetchUrl, { signal: activeFetchController.signal })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Get product cards
      const newCards = doc.querySelectorAll("product-grid-item");
      gridContainer.innerHTML = "";

      if (newCards.length > 0) {
        newCards.forEach((card) => {
          const wrapper = document.createElement("div");
          wrapper.style.width = "392px";
          wrapper.style.maxWidth = "100%";
          wrapper.style.margin = "auto";
          wrapper.appendChild(card);
          gridContainer.appendChild(wrapper);
        });
          setTimeout(function () {
            initSwatchSlider();
            swatchimage_change();
          }, 2500);
      } else {
        const rawGrid = doc.querySelector(".collection__products .js-grid");
        if (rawGrid) {
          gridContainer.innerHTML = rawGrid.innerHTML;
          setTimeout(function () {
            initSwatchSlider();
            swatchimage_change();
          }, 2500);
        } else {
          gridContainer.innerHTML =
            '<p style="text-align:center;">No matching products found.</p>';
        }
      }

      // Update count safely
      const newCount = doc.querySelector(".collection__count");
      const countContainer = document.querySelector(".collection__count");
      if (newCount && countContainer) {
        countContainer.innerHTML = newCount.innerHTML;
      }

      // Check if we need to show pagination
      const paginationFromResponse = doc.querySelector(".pagination-custom");
      const currentPagination = document.querySelector(".pagination-custom");
      
      if (paginationFromResponse && currentPagination) {
        // Show pagination if it exists in the response and has multiple pages
        const paginationLinks = paginationFromResponse.querySelectorAll("a");
        if (paginationLinks.length > 0) {
          currentPagination.style.display = "block";
          currentPagination.innerHTML = paginationFromResponse.innerHTML;
        } else {
          currentPagination.style.display = "none";
        }
      } else if (currentPagination) {
        // Hide pagination if it doesn't exist in the response
        currentPagination.style.display = "none";
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      console.error("Fetch failed:", error);

      // Show graceful fallback instead of breaking
      gridContainer.innerHTML =
        '<p style="text-align:center;">Error loading products. Please try again.</p>';
      
      // Show pagination again on error
      const paginationContainer = document.querySelector(".pagination-custom");
      if (paginationContainer) {
        paginationContainer.style.display = "block";
      }
    }); 
  
  const wrapper = document.querySelector(".collection__active__filters__wrapper .collection__active__filters__wrapper");
  if (wrapper) {
    wrapper.classList.remove("is-hidden");
  }

  // Close style list accordion
  const stylesButton = document.querySelector(".sidebar__heading.js.custom_sty");
  if (stylesButton) {
    stylesButton.click(); // simulate user click to close accordion
  }

  // Breadcrumb injection
  const activeFiltersContainer = document.querySelector(".active-style");
  if (activeFiltersContainer) {
    const existing = activeFiltersContainer.querySelector(
      ".active__filters__remove.style-tag"
    );
    if (existing) existing.remove();

    const displayText =
      constraintTag === "all"
        ? "All Styles"
        : constraintTag.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

    const a = document.createElement("a");
    a.className = "active__filters__remove style-tag";
    a.href = window.location.pathname;
    a.setAttribute("data-style-remove", constraintTag);
    a.innerHTML = `${displayText} <span class="filter__x">X</span>`;
    activeFiltersContainer.prepend(a);

    a.addEventListener("click", function (e) {
      e.preventDefault();
      document
        .querySelector('.style-list li[data-style-filter="all"]')
        ?.click();
      a.remove();
    });
  }
}

  // Pagination Click Handler (unchanged for collections, excluded for blogs)
  document.addEventListener("click", function (e) {
    // Skip if
    if (
      document.body.classList.contains('template-blog') || 
      document.body.classList.contains('template-search') || 
      document.body.classList.contains('template-customers-account')
    ) return;

    const target = e.target.closest(".pagination-custom a");
    if (!target) return;
    e.preventDefault();

    const gridContainer = document.querySelector(
      ".collection__products .js-grid"
    );
    if (!gridContainer) return;

    gridContainer.innerHTML =
      '<p class="loading" style="text-align: center;">Loading...</p>';
    const url = target.href;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCards = doc.querySelectorAll("product-grid-item");

        gridContainer.innerHTML = "";

        if (newCards.length > 0) {
          newCards.forEach((card) => {
            const wrapper = document.createElement("div");
            wrapper.style.width = "392px";
            wrapper.style.maxWidth = "100%";
            wrapper.style.margin = "auto";
            wrapper.appendChild(card);
            gridContainer.appendChild(wrapper);
          });


            initSwatchSlider();
            swatchimage_change();
            initStyleFilter(); // Rebind again after loading new content
        } else {
          gridContainer.innerHTML =
            '<p style="text-align: center;">No more results found.</p>';
        }
      })
      .catch((error) => {
        console.error("Pagination fetch failed:", error);
        gridContainer.innerHTML =
          '<p style="text-align: center;">Error loading page.</p>';
      });
  });
})();

//Notify CTA on product ppage
document.addEventListener("DOMContentLoaded", function () {
  const eligibilityScript = document.getElementById(
    "attn-waitlist-eligibility"
  );
  const triggerDiv = document.getElementById("attn-waitlist-trigger");
  if (!eligibilityScript || !triggerDiv) {
    console.warn("[Attentive] Required elements not found");
    return;
  }
  const outOfStockMap = JSON.parse(eligibilityScript.textContent || "{}");
 
  function handleSwatchClick(variantId) {
    const isOutOfStock = outOfStockMap[variantId] === true;

    triggerDiv.setAttribute("data-product-id", variantId);
    if (isOutOfStock) {
      triggerDiv.style.display = "block";
    } else {
      triggerDiv.style.display = "none";
    }

    if (typeof attn === "function" && attn.refresh) {
      attn("refresh");
    }
  }
  // Attach listeners to each size swatch input
  const swatchInputs = document.querySelectorAll('.radio__inputs input[type="radio"].size-box' );
  swatchInputs.forEach((input) => {
    const variantId = input.getAttribute("data-vid");
    if (!variantId) return;

    input.addEventListener("click", () => {
      handleSwatchClick(variantId);
    });

    input.addEventListener("change", () => {
      handleSwatchClick(variantId);
    });
  });
});